<template>
    <div class="p-3">
        <h3>Detail Pasien Tidak Aktif</h3>
        <hr>

        <div class="row">
            <div class="col">
                <h4 class="mb-3">Data Pasien</h4>

                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-header text-white bg-primary">Data Pasien</div>
                            <div class="card-body">
                                <div class="row mb-3 fw-bold">
                                    <div class="col-sm-4 alert alert-primary text-end">Field</div>
                                    <div class="col alert alert-primary text-center">Data Pasien</div>
                                </div>
                                <template v-for="(pasien, idx) in updated_pasiens">
                                    <div class="row mb-3" :key="idx" v-if="input_labels[idx]">
                                        <label :for="idx" class="col-sm-4 col-form-label text-end">{{ input_labels[idx] }}</label>
                                        <div class="col">
                                            <input type="text" :name="`${idx}-original`" :id="`${idx}1`" :value="detail_pasien[idx]" disabled class="form-control">
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-header text-white bg-primary">Data Registrasi</div>
                            <div class="card-body">
                                <div class="row mb-3 fw-bold">
                                    <div class="col-sm-4 alert alert-primary text-end">Nomor Registrasi</div>
                                    <div class="col-sm-4 alert alert-primary text-center">Tanggal Registrasi</div>
                                    <div class="col-sm-4 alert alert-primary text-center">Poli</div>
                                </div>
                                <div class="row mb-3" v-for="(register, idx) in data_registrasi" :key="idx">
                                    <label :for="idx" class="col-sm-4 col-form-label text-end">{{ register.Regno }}</label>
                                    <div class="col-sm-4">
                                        <input type="text" :value="register.Regdate" disabled class="form-control">
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="text" :value="register.poli.NMPoli" disabled class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mt-3">
                            <div class="card-header text-white bg-primary">
                                Scan Dokumen
                            </div>
                            <div class="card-body">
                                <router-link class="btn btn-sm btn-success" :to="`/daftar-dokumen-pasien/${Medrec}`">Daftar Dokumen Pasien</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Medrec: '',
            detail_pasien: [],
            updated_pasiens: [],
            data_registrasi: [],
            input_labels: {
                'Medrec': 'No Rekam Medis',
                'Firstname': 'Nama Lengkap',
                'Pod': 'Tempat Lahir',
                'Bod': 'Tangal Lahir',
                'UmurThn': 'Umur (Tahun)',
                'UmurBln': 'Umur (Bulan)',
                'UmurHr': 'Umur (Hari)',
                'Sex': 'Jenis Kelamin',
                'GolDarah': 'Golongan Darah',
                'RHDarah': 'RH Darah',
                'WargaNegara': 'Warga Negara',
                'NoIden': 'NIK',
                'Perkawinan': 'Status Perkawinan',
                'Agama': 'Agama',
                'Pendidikan': 'Pendidikan',
                'NamaAyah': 'Nama Ayah',
                'NamaIbu': 'Nama Ibu',
                'AskesNo': 'No Kartu BPJS',
                'TglDaftar': 'Tanggal Daftar',
                'Address': 'Alamat',
                'City': 'Kota',
                'Propinsi': 'Propinsi',
                'Kecamatan': 'Kecamatan',
                'Kelurahan': 'Kelurahan',
                'KdPos': 'Kode Pos',
                'Phone': 'No Telp',
                'Kategori': 'Kategori',
                'Pekerjaan': 'Pekerjaan',
                'NamaPJ': 'Nama Penanggung Jawab',
                'HubunganPJ': 'Hubungan Penanggung Jawab',
                'PekerjaanPJ': 'Pekerjaan Penanggung Jawab',
                'PhonePJ': 'No Telp Penanggung Jawab',
                'AlamatPJ': 'Alamat Penanggung Jawab',
                'NmSuku': 'Nama Suku',
                'Keyakinan': 'Keyakinan',
                'alamat_ktp': 'Alamat KTP',
            },
        }
    },
    created() {
        this.Medrec = this.$route.params.Medrec
    },
    mounted() {
        this.getDetailPasien()
    },
    updated() {
        this.updated_pasiens.tgl_lahir = this.updated_pasiens.Bod
        this.updated_pasiens.tgl_daftar = this.updated_pasiens.TglDaftar
        this.updated_pasiens.no_telp = this.updated_pasiens.Phone
    },
    methods: {
        getDetailPasien() {
            const uri = `/api/retensi-dan-pemusnahan/get-detail-pasien?Medrec=${this.Medrec}`

            this.axios.get(uri).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.detail_pasien = response.data.pasien
                    this.updated_pasiens = { ...this.detail_pasien }
                    this.data_registrasi = this.detail_pasien.registers
                }
            })
        },
    }
}
</script>